import React from 'react';
import { Shield, Mail, Phone, MapPin } from 'lucide-react';
import logo from '/assets/logo.png';

interface FooterProps {
  setCurrentPage: (page: string) => void;
}

const Footer: React.FC<FooterProps> = ({ setCurrentPage }) => {
  const handleNavigation = (page: string) => {
    setCurrentPage(page);
  };

  const industries = [
    { name: 'Financial Services', page: 'financial-services' },
    { name: 'Healthcare', page: 'healthcare' },
    { name: 'Government', page: 'government' },
    { name: 'Manufacturing', page: 'manufacturing' },
    { name: 'Retail', page: 'retail' },
    { name: 'Technology', page: 'technology' },
    { name: 'Education', page: 'education' }
  ];

  return (
    <footer className="nav-blur border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div 
              className="flex items-center mb-4 cursor-pointer"
              onClick={() => handleNavigation('home')}
            >
              <img src={logo} alt="AstronShield" className="h-14 w-auto" />
              <span className="ml-2 text-xl font-bold text-gradient">AstronShield</span>
            </div>
            <p className="text-muted">
              Leading provider of advanced cybersecurity solutions protecting businesses worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleNavigation('home')}
                  className="text-muted hover:text-primary transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('solutions')}
                  className="text-muted hover:text-primary transition-colors"
                >
                  Solutions
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('services-overview')}
                  className="text-muted hover:text-primary transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('consulting-overview')}
                  className="text-muted hover:text-primary transition-colors"
                >
                  Consulting
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('about')}
                  className="text-muted hover:text-primary transition-colors"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('contact')}
                  className="text-muted hover:text-primary transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Industries</h3>
            <ul className="space-y-2">
              {industries.map((industry, index) => (
                <li key={index}>
                  <button 
                    onClick={() => handleNavigation(industry.page)}
                    className="text-muted hover:text-primary transition-colors"
                  >
                    {industry.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 text-primary" />
                <a href="mailto:contact@astronshield.com" className="text-muted hover:text-primary transition-colors">
                  contact@astronshield.com
                </a>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 mr-2 text-primary" />
                <a href="tel:+18889917050" className="text-muted hover:text-primary transition-colors">
                  (888) 991-7050
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 text-primary mt-1" />
                <span className="text-muted">
                  Cleveland, OH<br />
                  United States
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
            <div className="text-muted text-center md:text-left">
              <p>&copy; {new Date().getFullYear()} AstronShield. All rights reserved.</p>
            </div>
            <div className="flex justify-center md:justify-end space-x-4">
              <button 
                onClick={() => handleNavigation('privacy')}
                className="text-muted hover:text-primary transition-colors"
              >
                Privacy Notice
              </button>
              <button 
                onClick={() => handleNavigation('terms')}
                className="text-muted hover:text-primary transition-colors"
              >
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;